'use strict';
import React from 'react';
import NavBar from '../navBar';
import SideMenu from '../sideMenu';
import Loading from '../loading';
import condoSetAction from '../../actions/condoSetAction';
import condoSetStore from '../../stores/condoSetStore';
import menuAction from '../../actions/menuAction';

class CondoDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            condo: condoSetStore.getState().condo,
            processing: condoSetStore.getState().processing,
            warningMsg: "",

        };
    }
    static defaultProps = {
        mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        roleTxt: [
            "Administrative Executive", "Property Executive", "Property Manager", "Human Resource Executive",
            "Contracts Management Executive", "Accounts Executive", "Accounts Manager", "Information Technology",
            "Managing Director", "Director", "Other", "Cleaner Supervisor", "Cleaner", "Landscaper", "Electrician", "Caretaker",
            "Portfolio Manager", "Team Manager", "Senior Admin Executive"
        ],
        statusTxt: [
            "Active", "In-Active"
        ],
        ctrStatusTxt: ["Active", "In-Active", "Terminated", "Ad hoc"],
    };
    componentDidMount() {
        condoSetStore.listen(this.onChange);
        menuAction.pageNumber({ selectedActivity: -1, selectedCategory: 0 });
        condoSetAction.clear();
        if (!this.state.processing) {
            condoSetAction.processing(true);
            condoSetAction.getCondo(this.props.match.params.id);
        }

    }
    componentWillUnmount() {
        condoSetStore.unlisten(this.onChange);
    }
    onChange(state) {
        this.setState({
            condo: state.condo,
            processing: state.processing,
        });
    }


    handleClick(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        if (index == 0) {
            window.print();
        } else if (index == 1) {
            if (this.props.processing) return;

            condoSetAction.processing(true);
            condoSetAction.exportCondo(this.props.match.params.id);
        } else {
            this.props.history.push('/contractor');
        }
    }
    generateDateFormat(date) {
        if (date) {
            return (
                date.getDate() + "-" + this.props.mthTxt[date.getMonth()] + "-" + date.getFullYear()
            );
        }
    }
    renderDetail(staff) {
        //address: "Blk 446 Hougang Ave 8", unitNo: "B1-1635", postal: "530446"
        if (!staff) return;
        return (
            <li>
                <div className="ct-li-group-1">
                    <label>Employee Name:</label>
                    <div className="ct-li-ct">{staff.userName}</div>
                </div>
                <div className="ct-li-group-1">
                    <label>Role:</label>
                    <div className="ct-li-ct">{this.props.roleTxt[staff.role]}</div>
                </div>
                <div className="ct-li-group-1">
                    <label>Email:</label>
                    <div className="ct-li-ct">{staff.email}</div>
                </div>
                <div className="ct-li-group-1">
                    <label>Handphone:</label>
                    <div className="ct-li-ct">{staff.handPhone ? staff.handPhone : "--"}</div>
                </div>
            </li>
        );
    }
    renderStaff(staff) {
        let managed = this.renderDetail(staff);
        return (
            <ul className="ct-aul" >
                {managed}
            </ul>
        )
    }
    renderConDetail(contractor) {
        let content = (
            <div className="cd-ct1 ">
                <div className="ct-col-1">
                    <div className="ct-li-group">
                        <label>email:</label>
                        <div className="ct-li-ct">{contractor.contractorEmail}</div>
                    </div>
                    <div className="ct-li-group">
                        <label>telephone:</label>
                        <div className="ct-li-ct">{contractor.telephone}</div>
                    </div>
                </div>
            </div>
        );
        let contentList = contractor.contract.map((detail, index) => {
            let contractStartDate = detail.contractStartDate ? this.generateDateFormat(new Date(detail.contractStartDate)) : "";
            let contractEndDate = detail.contractEndDate ? this.generateDateFormat(new Date(detail.contractEndDate)) : "";
            let firstReminder = detail.firstReminder ? this.generateDateFormat(new Date(detail.firstReminder)) : "";
            let secReminder = detail.secondReminder ? this.generateDateFormat(new Date(detail.secondReminder)) : "";
            let lastVisit = detail.lastVisit ? this.generateDateFormat(new Date(detail.lastVisit)) : "";
            let dueDays = 0;
            if (detail.contractEndDate) {
                dueDays = Math.ceil((new Date(detail.contractEndDate).getTime() - new Date().getTime()) / 1000 / 3600 / 24);
            }
            return (
                <li key={index}>
                    <div className="ct-col-1">
                        <div className="ct-li-group">
                            <label>Service:</label>
                            <div className="ct-li-ct">{detail.service}</div>
                        </div>
                        <div className="ct-li-group">
                            <label>Description:</label>
                            <div className="ct-li-ct">{detail.description}</div>
                        </div>
                        <div className="ct-li-group">
                            <label>Last Visit:</label>
                            <div className="ct-li-ct">{lastVisit ? lastVisit : "--"}</div>
                        </div>
                        <div className="ct-li-group">
                            <label>Remark:</label>
                            <div className="ct-li-ct">{detail.remark ? detail.remark : "--"}</div>
                        </div>
                        <div className="ct-li-group">
                            <label>Amount (SGD):</label>
                            <div className="ct-li-ct">{detail.amount ? "$" + detail.amount : "--"}</div>
                        </div>
                    </div>
                    <div className="ct-col-2">
                        <div className="ct-li-group">
                            <label>Status</label>
                            <div className="ct-li-ct">{typeof detail.status == 'number' ? this.props.ctrStatusTxt[detail.status] : "--"}</div>
                        </div>
                        <div className="ct-li-group">
                            <label >Contract Start Date:</label>
                            <div className="ct-li-ct">{contractStartDate ? contractStartDate : "--"}</div>
                        </div>
                        <div className="ct-li-group">
                            <label >Contract End Date:</label>
                            <div className="ct-li-ct">{contractEndDate ? contractEndDate : "--"}</div>
                        </div>

                        <div className="ct-li-group">
                            <label>Contract Due In (days):</label>
                            <div className={"ct-li-ct " + (dueDays >= 0 ? "ct-green" : "ct-red")}>{dueDays ? dueDays : "--"}</div>
                        </div>
                        <div className="ct-li-group">
                            <label >First Reminder:</label>
                            <div className="ct-li-ct">{firstReminder ? firstReminder : "--"}</div>
                        </div>
                        <div className="ct-li-group">
                            <label >Second Reminder:</label>
                            <div className="ct-li-ct">{secReminder ? secReminder : "--"}</div>
                        </div>
                    </div>
                </li>
            );
        });
        return (
            <div className="cd-wp">
                {content}
                <ul className="ct-cul ">
                    {contentList}
                </ul>
            </div>
        );
    }
    renderContractor() {
        let s = this.state.condo;

        return s.contractors.map((contractor, index) => {
            return (
                <div key={index}>
                    <div className="ct-cli" key={index}>
                        <div className="ct-cn" >{contractor.contractorName}</div>
                    </div>
                    {this.renderConDetail(contractor)}
                </div>
            );
        })
    }



    render() {
        let s = this.state.condo;

        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <Loading {...this.props} processing={this.state.processing} />
                    <div className=" col-md-10  col-sm-8 us-form">
                        <div className="condo-form">
                            <div className="row">
                                <div className="col-sm-6">
                                    <h4><b>Estate Details</b></h4>
                                    <div className="form-group">
                                        <label htmlFor="mcst">MCST</label>
                                        <div className="ct-item">{s.mcst}</div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="condoName">Estate Name</label>
                                        <div className="ct-item">{s.condoName}</div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="noUnit">No of Units</label>
                                        <div className="ct-item">{s.noUnit}</div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="address">Address</label>
                                        <div className="ct-item">{s.address}</div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="postal">Postal</label>
                                        <div className="ct-item">{s.postal}</div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="status">Status</label>
                                        <div className="ct-item">{this.props.statusTxt[s.status]}</div>
                                    </div>
                                    <label htmlFor="manageBy">Managed By:</label>
                                    {this.renderStaff(s.manageBy)}
                                    <label htmlFor="manageBy">Manager:</label>
                                    {this.renderStaff(s.supervisor)}
                                </div>
                                <div className="col-sm-6">
                                    <h5><b>Contractors</b></h5>
                                    {this.renderContractor()}
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="warning">{this.state.warningMsg}</div>
                                    <button type="button" className="btn btn-primary us-cr"
                                        data-index="0" onClick={this.handleClick}>Print</button>
                                    <button type="button" className="btn btn-primary us-cr"
                                        data-index="1" onClick={this.handleClick}>Export</button>
                                    <button type="button" className="btn btn-default us-cr"
                                        data-index="2" onClick={this.handleClick}>Cancel</button>
                                </div>
                                <div className="clear"></div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default CondoDisplay;


// WEBPACK FOOTER //
// ./app/components/condoComponents/condoDisplay.js